import React, { useRef, useState, useEffect } from "react";

const CustomProgressBar = ({
  progress,
  onSeek,
  fullScreen,
  show = false,
}: any) => {
  const progressBarRef = useRef<any>(null);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleMove = (e: any) => {
      if (isDragging) {
        const progressBar = progressBarRef.current;
        if (progressBar) {
          const rect = progressBar.getBoundingClientRect();
          const progressBarWidth = rect.width;
          let offsetX;
          if (e.type === "touchmove") {
            offsetX = e.touches[0].clientX - rect.left;
          } else {
            offsetX = e.clientX - rect.left;
          }
          offsetX = Math.min(progressBarWidth, Math.max(0, offsetX));
          const seekPercentage = (offsetX / progressBarWidth) * 100;
          onSeek(seekPercentage);
        }
      }
    };

    const handleMouseDown = (e: any) => {
      setIsDragging(true);
      handleMove(e);
    };

    const handleTouchMove = (e: any) => {
      handleMove(e);
    };

    const handleTouchStart = (e: any) => {
      setIsDragging(true);
      handleMove(e);
    };

    const handleEnd = () => {
      setIsDragging(false);
    };

    const progressBar = progressBarRef.current;
    if (progressBar) {
      progressBar.addEventListener("mousedown", handleMouseDown);
      progressBar.addEventListener("touchstart", handleTouchStart);
    }

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchend", handleEnd);

    return () => {
      if (progressBar) {
        progressBar.removeEventListener("mousedown", handleMouseDown);
        progressBar.removeEventListener("touchstart", handleTouchStart);
      }
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchend", handleEnd);
    };
  }, [isDragging, progressBarRef, onSeek]);

  const handleSeekByClick = (e: any) => {
    const rect = progressBarRef.current.getBoundingClientRect();
    // subtract the bar's left offset so the click maps to the correct position
    const offsetX = Math.min(rect.width, Math.max(0, e.clientX - rect.left));
    const p = (offsetX / rect.width) * 100;
    onSeek(p);
  };

  return (
    <div
      className={`group relative flex w-full cursor-pointer items-center py-[2px] max-md:mx-auto max-md:w-[95%] ${
        fullScreen ? "z-50" : ""
      } ${show && fullScreen ? "hidden" : ""}`}
      ref={progressBarRef}
      onClick={handleSeekByClick}
    >
      {/* track */}
      <div className="h-[3px] w-full rounded-full bg-white/20 transition-all duration-150 group-hover:h-[5px]">
        {/* filled */}
        <div
          style={{ width: `${progress}%` }}
          className="relative h-full rounded-full bg-[#FF0000]"
        >
          {/* handle: hidden until hover / drag */}
          <div
            className={`absolute right-0 top-1/2 h-3 w-3 -translate-y-1/2 translate-x-1/2 rounded-full bg-[#FF0000] shadow-md transition-opacity duration-150 ${
              isDragging ? "opacity-100" : "opacity-0 group-hover:opacity-100"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomProgressBar;